// This file provides wrappers for react-i18next utility functions in order to make it easier to
// co-locate the localization file alongside the React component using it.

import i18next, { i18n as I18n } from 'i18next';
import React from 'react';
import {
    useTranslation as i18nUseTranslation,
    Trans as I18nTrans,
} from 'react-i18next';
import en from './translations/en.json';
import nl from './translations/nl.json';

// i18next requires a namespace. This can be anything.
const NAMESPACE = 'results-template';

const resources = {
    'en-US': {
        [NAMESPACE]: en,
    },
    'nl-NL': {
        [NAMESPACE]: nl,
    },
};

/**
 * Returns an instance of i18next given a locale.
 * @returns {Object} i18next instance
 */
export function i18nFromLocale(): I18n {
    const LANGUAGE = 'nl-NL';

    return i18next.createInstance(
        {
            lng: LANGUAGE,
            fallbackLng: 'en-US',
            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            },
            resources,
        },
        () => {},
    );
}

export const i18n = i18nFromLocale();

/**
 * Wraps useTranslation() from react-i18next that abstracts the default namespace.
 * @returns see https://react.i18next.com/latest/usetranslation-hook
 */
export function useTranslation() {
    return i18nUseTranslation(NAMESPACE, { i18n });
}

export function Trans(props: {
    i18nKey: string;
    components?: any;
    values?: any;
}): React.ReactElement {
    const { i18nKey, components, values } = props;
    return (
        <I18nTrans
            {...props}
            ns={NAMESPACE}
            i18n={i18n}
            i18nKey={i18nKey}
            components={components}
            values={values}
        />
    );
}

/**
 * Replacement for withTransition() from react-i18next that abstracts the default namespace.
 * @returns see https://react.i18next.com/latest/withtranslation-hoc
 * @param i18n
 */
// export function withTranslation(i18n: any) {
//     return function Extend(WrappedComponent: string) {
//         function I18nextWithTranslation({ forwardedRef, ...rest }) {
//             const [t, ready] = useTranslation(i18n);
//
//             const passDownProps = {
//                 ...rest,
//                 ref: forwardedRef,
//                 t,
//                 i18n,
//                 tReady: ready,
//             };
//             return React.createElement(WrappedComponent, passDownProps);
//         }
//
//         I18nextWithTranslation.propTypes = {
//             forwardedRef: PropTypes.oneOfType([
//                 PropTypes.func,
//                 PropTypes.shape({ current: PropTypes.any }),
//             ]),
//         };
//
//         I18nextWithTranslation.displayName = `withI18nextTranslation(${WrappedComponent.displayName})`;
//
//         I18nextWithTranslation.WrappedComponent = WrappedComponent;
//
//         const forwardRef = (props, ref) =>
//             React.createElement(I18nextWithTranslation, Object.assign({}, props, { forwardedRef: ref }));
//
//         return React.forwardRef(forwardRef);
//     };
// }
